const DEFAULT_IPFS_GATEWAY = "https://gateway.pinata.cloud/ipfs/";

export function toImageSrc(value: string | undefined): string {
  if (!value) return "";
  if (value.startsWith("data:") || value.startsWith("http://") || value.startsWith("https://")) return value;
  if (value.startsWith("ipfs://")) return `${DEFAULT_IPFS_GATEWAY}${value.slice("ipfs://".length)}`;
  return `${DEFAULT_IPFS_GATEWAY}${value}`;
}
